const HeroSection = () => {
  return (
    <section
      className="py-20 px-6"
      style={{ backgroundColor: 'var(--color-body-bg)' }}
    >
      <div className="max-w-4xl mx-auto text-center">
        <h1
          className="text-5xl md:text-6xl font-bold mb-6"
          style={{ color: 'var(--color-heading)' }}
        >
          Get in Touch
        </h1>
        <p
          className="text-xl md:text-2xl max-w-2xl mx-auto"
          style={{ color: 'var(--color-subheading)' }}
        >
          I'm always open to discussing new opportunities, collaborations, or
          just having a conversation about chess, robotics, and technology.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
